import { useSession } from "shared/hooks/useSession";

const SUPER_USER_ROLE = "SuperUser";

// Только про видимость в интерфейсе: права проверяет бэк на каждой ручке.
export const useIsSuperUser = (): boolean => {
    const { account } = useSession();

    return Boolean(account?.roles.includes(SUPER_USER_ROLE));
};
